import * as utils from '@utils/form';
import { IMAGE_SIZE } from '@api/media/constants';
import { hexRegex } from '@utils/validator';

export const FORM_FIELD = {
  NAME: {
    name: 'name',
    label: 'Minisite name:',
    placeholder: 'Enter a name',
    rules: [{ required: true, message: 'Name is required' }],
  },
  LOGO: {
    name: 'logo',
    label: 'Logo:',
    buttonText: 'CHOOSE A NEW LOGO',
    rules: [{ required: true, message: 'Logo is required' }],
    size: IMAGE_SIZE['300x75'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  FEATURE_IMAGE: {
    name: 'featureImage',
    label: 'Feature image:',
    rules: [{ required: true, message: 'Feature image is required' }],
    size: IMAGE_SIZE['2000x1333'],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
    deserializeError: utils.deserializeErrorRelatedField,
  },
  PRIMARY_COLOR: {
    name: 'primaryColor',
    label: 'Primary:',
    placeholder: '#0e003c',
    rules: [
      { required: true, message: 'Primary color is required' },
      { pattern: hexRegex, message: 'The primary color should be HEX' },
    ],
  },
  SECONDARY_COLOR: {
    name: 'secondaryColor',
    label: 'Secondary:',
    placeholder: '#00FFFF',
    rules: [
      { required: true, message: 'Secondary color is required' },
      { pattern: hexRegex, message: 'The secondary color should be HEX' },
    ],
  },
};
